"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetAllAttributeValuesForStrategyMatrix = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const gql_1 = require("../gql");
const client_constants_1 = require("../../../client/client.constants");
const client_utils_1 = require("../../../client/client.utils");
const useGetAllAttributeValuesForStrategyMatrix = ({ productTreeNodeId, catalog, selectedAttribute, }) => {
    const filter = (0, react_1.useMemo)(() => (selectedAttribute ? { some: { label: { equals: selectedAttribute } } } : undefined), [selectedAttribute]);
    const [allEdges, setAllEdges] = (0, react_1.useState)([]);
    const [fullyLoaded, setFullyLoaded] = (0, react_1.useState)(false);
    // A ref to ensure we don’t fetch again while still fetching.
    const isFetching = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        isFetching.current = false;
        setAllEdges([]);
        setFullyLoaded(false);
    }, [productTreeNodeId, catalog, selectedAttribute]);
    const { data, error, networkStatus, fetchMore, } = (0, react_2.useQuery)(gql_1.GET_ALL_ATTRIBUTE_VALUES_FOR_STRATEGY_MATRIX, {
        variables: {
            productTreeNodeId,
            first: client_constants_1.REQUEST_LIMIT_MAX,
            filter,
            after: null,
        },
        skip: !productTreeNodeId || !selectedAttribute || !catalog,
        notifyOnNetworkStatusChange: true,
    });
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (!data || fullyLoaded || isFetching.current) {
            return undefined;
        }
        let isCancelled = false;
        const initialEdges = (_g = (_f = (_e = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _a === void 0 ? void 0 : _a.labelValidation) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.node) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.edges) !== null && _g !== void 0 ? _g : [];
        setAllEdges(initialEdges);
        let pageInfo = (_o = (_m = (_l = (_k = (_j = (_h = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _h === void 0 ? void 0 : _h.labelValidation) === null || _j === void 0 ? void 0 : _j.edges) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.node) === null || _m === void 0 ? void 0 : _m.values) === null || _o === void 0 ? void 0 : _o.pageInfo;
        let aggregatedEdges = [...initialEdges];
        const fetchAllPages = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            isFetching.current = true;
            while (!isCancelled && (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage)) {
                try {
                    // eslint-disable-next-line no-await-in-loop
                    const { data: moreData } = yield fetchMore({
                        variables: {
                            first: client_constants_1.REQUEST_LIMIT_MAX,
                            after: pageInfo.endCursor,
                        },
                    });
                    if (isCancelled)
                        return;
                    const newEdges = (_g = (_f = (_e = (_d = (_c = (_b = (_a = moreData === null || moreData === void 0 ? void 0 : moreData.productTreeNode) === null || _a === void 0 ? void 0 : _a.labelValidation) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.node) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.edges) !== null && _g !== void 0 ? _g : [];
                    const newPageInfo = (_o = (_m = (_l = (_k = (_j = (_h = moreData === null || moreData === void 0 ? void 0 : moreData.productTreeNode) === null || _h === void 0 ? void 0 : _h.labelValidation) === null || _j === void 0 ? void 0 : _j.edges) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.node) === null || _m === void 0 ? void 0 : _m.values) === null || _o === void 0 ? void 0 : _o.pageInfo;
                    if (!newEdges.length || newPageInfo.endCursor === pageInfo.endCursor) {
                        break;
                    }
                    aggregatedEdges = [...aggregatedEdges, ...newEdges];
                    setAllEdges(aggregatedEdges);
                    pageInfo = newPageInfo;
                }
                catch (err) {
                    console.error('Error fetching more pages:', err);
                    break;
                }
            }
            if (isCancelled)
                return;
            setFullyLoaded(true);
            isFetching.current = false;
        });
        void fetchAllPages();
        return () => {
            isCancelled = true;
            isFetching.current = false;
        };
    }, [catalog, data, fetchMore, fullyLoaded, productTreeNodeId, selectedAttribute]);
    return {
        data: allEdges,
        isLoading: (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus) && !fullyLoaded,
        error: error === null || error === void 0 ? void 0 : error.message,
    };
};
exports.useGetAllAttributeValuesForStrategyMatrix = useGetAllAttributeValuesForStrategyMatrix;
